<template>
<div>
  <v-btn @click="$router.push({ name:'schema-related-map', params: { schemaId: $route.params.schemaId }})">
    <v-icon>
      arrow_left
    </v-icon>
  </v-btn>
  <h2>Mapowanie</h2>
  <v-container>
      <v-form ref="form">

        <v-tooltip>
          <template slot="activator">
            <v-icon>info</v-icon>
          </template>
          <p>Należy podać schemat powstawania nazwy oraz kodu.</p>
          <p>Przykład: '{f1} {f2}' - oznacza, że nazwa powstanie z wartości pierwszgeo oraz drugiego pola </p>
        </v-tooltip>

        <v-select @change="relatedSchemaChanged()" v-model="relatedSchemaId" label="Schemat relacyjny"
                  :items="relatedSchemas"
                  item-text="name"
                  item-value="id"
        ></v-select>


        <v-text-field label="Kod" v-model="relatedValueCode"></v-text-field>
        <v-text-field label="Nazwa" v-model="relatedValueName"></v-text-field>

        <v-select style="max-width:400px" v-for="field in fields" :key="field.id + relatedSchemaId"
                  v-model="model[field.id]"
                  :label="field.name"
                  :items="relatedSchemaKeys"
                  item-text="name"
                  item-value="order"
        ></v-select>

        <v-checkbox
          label="Tworzyć grupe relacyjna?"
          v-model="typeGroupAvaliblle"
        ></v-checkbox>

        <div v-if="typeGroupAvaliblle">

          <v-select
            v-model="typeGroupId"
            label="Wybierz typ grupy"
            :items="getGroups"
            item-text="name"
            item-value="id"
            ></v-select>

          <v-text-field label="Kod" v-model="typeCode"></v-text-field>
          <v-text-field label="Nazwa" v-model="typeName"></v-text-field>

        </div>
        <v-btn @click="submit()">Submit</v-btn>
      </v-form>
  </v-container>
</div>
</template>

<script>
export default {
  data() {
    return {
      relatedSchemaId: null,
      schema: {},
      model: {},
      map: [],
      typeGroupAvaliblle: false,
      typeAvaliblle: [],
      schemaFields: [],
      relatedSchemas:[],
      relatedSchemaKeys:[],
      relatedValueCode: "",
      relatedValueName:"",
      typeGroups: [],
      typeGroupId: null,
      typeCode: null,
      typeName: null

    }
  },
  computed: {
    getGroups(){
      if(this.relatedSchemaId == null){
        return this.typeGroups
      }

      return this.typeGroups.filter(e => e.related_schema_id == this.relatedSchemaId)
    },
    fields() {
      let fields = []
      this.schemaFields.forEach(field => {
        fields.push(field)
        if (field['sub-fields'] != undefined) {
          field['sub-fields'].forEach(subField => fields.push(subField))
        }
      })
      return fields
    }
  },
  methods: {
    submit() {
      if (!this.$refs.form.validate()) {
        return
      }

      let postData = this.createPostData()

      this.$http.post(`schema/${this.$route.params.schemaId}/map-to-related`, postData).then(data => {
        this.map.push(data.data)
        this.$store.commit('setSnack', {
          message: "Dodano mapowanie",
          color: 'success'
        })

        this.$router.push({ name: 'schema-related-map', params: { schemaId: this.$route.params.schemaId } })
      }).catch(() => {
        this.$store.commit('setSnack', {
          message: "Problem z dodaniem tłumaczenia",
          color: 'success'
        })
      })
    },
    createPostData() {
      return {
        'map': this.fieldsMap(),
        'schemaId' : this.$route.params.schemaId,
        'relatedSchemaId' : this.relatedSchemaId,
        'relatedValueCode' : this.relatedValueCode,
        'relatedValueName' : this.relatedValueName,
        'groupName' : this.typeName,
        'groupCode' : this.typeCode,
        'type_group_id' : this.typeGroupId
      }
    },
    fieldsMap() {
      let fieldsMap = []
      for (let fieldId in this.model) {
        fieldsMap.push({
          'id_field': fieldId,
          'key': this.model[fieldId]
        })
      }

      return fieldsMap
    },
    initModel() {
      this.map.forEach(fieldMap => this.model[fieldMap['id_field']] = fieldMap['location'])
    },
    relatedSchemaChanged(){
      this.$http.get('related/schema/' + this.relatedSchemaId ).then( data=>{
        this.relatedSchemaKeys = data.data.keys
      })
    }
  },
  created() {
    let schema = this.$http.get('schema/' + this.$route.params.schemaId)
    let relatedSchemas = this.$http.get('related/schema')
    let groups = this.$http.get('related/group/type')

    Promise.all([schema, relatedSchemas,groups]).then((data) => {
      this.schemaFields = data[0].data.fields
      this.schema = data[0].data
      this.relatedSchemas = data[1].data
      this.typeGroups = data[2].data
      this.initModel()
    }).catch(() => {
      this.$route.push({
        name: "not-found"
      })
    });
  },
  watch:{
    relatedSchemaId: function (){
      this.typeGroupId = null
    }
  }
}
</script>
